import styled from 'styled-components';

const ReportLeaseGeneralColumn = styled.span`
  white-space: pre-wrap;
`;

export { ReportLeaseGeneralColumn };
